import * as _ from 'lodash'

import DynamicSectionElement from '@/scripts/dynamic-section-element.js'

const decode = str => decodeURIComponent(str).replace(/\+/g, ' ')

const MINI_CART_CONTAINER_SELECTOR = '.js-mini-cart-container'
const TABLET_BREAK_POINT = 768
class Cart extends DynamicSectionElement {
  constructor () {
    super()

    // Bind update method so it can be passed as callback argument
    this.onCartUpdate = this.onCartUpdate.bind(this)
    this.overlayEls = this.querySelectorAll('.js-overlay')

    this.getHeightHeaderCart()

    this.miniCartContainerEl = null

    this.handleQuantityChange = _.debounce((event) => {
      this.updateQuantity(event.target)
    }, 500, { leading: false, trailing: true })

    // Use debounced event handler to update cart quanties
    this.addEventListener('change-quantity', (e) => {
      this.setAttribute('data-loading', true)
      this.handleQuantityChange(e)
      const statusTrigger = e.target.getAttribute('data-trigger')

      if (statusTrigger == 'plus') {
        const productEl = e.target.closest('cart-item')
        this.addDatalayer(productEl)
      }
    })

    this.overlayEls.forEach(overlay => {
      overlay.addEventListener('focus', () => {
        const buttonClose = this.querySelector('.js-close-cart')
        setTimeout(() => {
          buttonClose.focus()
        }, 200);
      })
    })

    this.lastScrollTop = 0

    this.initDetectScroll()
    window.addEventListener('resize', _.debounce(() => {
      this.initDetectScroll.bind(this)
      this.getHeightHeaderCart()
    }, 100))
    /**
     * Fetch components on page load to make sure all user information are display correctly.
     * Add a small delay to make sure everything work
     */
    setTimeout(() => {
      this.fetchComponents()
    }, 350)
  }

  addDatalayer (item) {
    const itemData = JSON.parse(decode(item.dataset.item))
    const itemCategories = JSON.parse(decode(item.getAttribute('data-categories')))
    const itemCategoriesString = itemCategories.toString().replace('[', '').replace(']', '')
    const index = (itemData.options_with_values || []).findIndex(option => option.name.toLowerCase() === 'color')
    const color = index > -1 ? itemData.options_with_values[index].value : ''
    const itemListName = item.getAttribute('data-item-list')
    const itemListId = itemListName.toLocaleLowerCase().replace(' ', '_')
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        items: [
          {
            item_id: itemData.sku,
            item_name: itemData.product_title,
            affiliation: "pavise",
            currency: window.BARREL && window.BARREL.currencyCode ? window.BARREL.currencyCode : 'USD',
            discount: itemData.discounts[0],
            index: 0,
            item_brand: itemData.vendor,
            item_category: itemCategoriesString,
            item_variant: color,
            item_list_id: itemListId,
            item_list_name: itemListName,
            price: (parseFloat(itemData.price) / 100).toFixed(2).toString(),
            quantity: itemData.quantity
          }
        ]
      }
    })
  }

  openDrawer (event) {
    if (event && event.preventDefault) {
      if (event.metaKey) {
        return
      }
      event.preventDefault()
    }

    this.classList.add('open')
    document.body.classList.add('overflow-hidden')
    this.getHeightHeaderCart()

    const eventOpen = new window.CustomEvent('open-mini-cart')
    document.dispatchEvent(eventOpen)
  }

  changeFocusState(event) {
    if (event && event.keyCode === 13) {
      if (event.metaKey) {
        return
      }
      event.preventDefault()

      this.openDrawer()
      const buttonClose = this.querySelector('.js-close-cart')
      setTimeout(() => {
        buttonClose.focus()
      }, 200);
    }
  }

  closeDrawer () {
    this.classList.remove('open')
    document.body.classList.remove('overflow-hidden')
  }

  fetchConfig (type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    }
  }

  fetchComponents () {
    fetch(`${window.location.pathname}?sections=site-header,cart,mini-cart,blog-listing-header&t=${Date.now()}`)
      .then(res => this.onCartUpdate(res, true))
  }

  updateQuantity (el) {
    this.setAttribute('data-loading', true)
    const line = el.dataset.index
    const quantity = el.dataset?.quantity ? el.dataset?.quantity : el.value
    const cartItem = el.closest('cart-item')
    let dataBundle = null
    let properties = {}

    if (cartItem.dataset.bundleProperties) {
      properties['_gtm_list_id'] = 'cart'
      properties['_gtm_list_name'] = 'Cart'
      dataBundle = JSON.parse(decode(cartItem.dataset.bundleProperties))
      if (dataBundle && dataBundle.length > 0) {
        dataBundle.map(data => {
          if (data[0] !== '_gtm_list_id' && data[0] !== '_gtm_list_name') {
            properties[data[0]] = quantity.toString()
          }
        })
      }
    }

    const config = this.fetchConfig()
    config.body = JSON.stringify({
      line,
      quantity,
      properties,
      sections: 'site-header,cart,mini-cart,blog-listing-header',
      sections_url: window.location.pathname
    })

    fetch('/cart/change', config)
      .then((response) => {
        this.onCartUpdate(response)
      })
  }

  // Add item to cart using HTML form data
  addItemFromForm (form) {
    const formData = new FormData(form)
    formData.append('sections', 'site-header,cart,mini-cart,blog-listing-header')
    formData.append('sections_url', window.location.pathname)

    this.setAttribute('data-loading', true)

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then((response) => {
      this.onCartUpdate(response)
      this.openDrawer()
    })
  }

  // Update items in cart using HTML form data
  updateFromForm (form) {
    const formData = new FormData(form)
    formData.append('sections', 'site-header,cart,mini-cart,blog-listing-header')
    formData.append('sections_url', window.location.pathname)

    this.setAttribute('data-loading', true)

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    }).then((response) => {
      this.onCartUpdate(response)
    })
  }

  // Remove an item from cart using line item key
  removeItem (key) {
    this.setAttribute('data-loading', true)

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        updates: { [key]: 0 },
        sections: 'site-header,cart,mini-cart,blog-listing-header',
        sections_url: window.location.pathname
      })
    }).then(this.onCartUpdate)
  }

  async onSwitchToSubscription (key, id, quantity, sellingPlanId, properties = {}) {
    this.setAttribute('data-loading', true)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        selling_plan: sellingPlanId,
        properties: {
          ...properties
        },
        sections: 'site-header,cart,mini-cart,blog-listing-header',
        sections_url: window.location.pathname
      })
    }).then(this.onCartUpdate)
  }

  async onUpdateDeliveryFrequency (key, quantity, sellingPlanId, properties = {}) {
    this.setAttribute('data-loading', true)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        selling_plan: sellingPlanId,
        properties: {
          ...properties
        },
        sections: 'site-header,cart,mini-cart,blog-listing-header',
        sections_url: window.location.pathname
      })
    }).then(this.onCartUpdate)
  }

  async onHandleFreeProduct (responseJson) {
    const sections = responseJson.sections ? responseJson.sections : responseJson
    if (!sections['mini-cart']) return
    const miniCartEl = new DOMParser().parseFromString(sections['mini-cart'], 'text/html')
    const shippingBarEl = miniCartEl.querySelector('shipping-bar')
    if (shippingBarEl) {
      const { id, key, addFreeProduct } = shippingBarEl.dataset
      if (id && addFreeProduct === 'true') {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            id: id,
            quantity: 1,
            sections: 'site-header,cart,mini-cart'
          })
        }).then(this.onCartUpdate)
        return
      }
      if (key && addFreeProduct === 'false') {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            updates: { [key]: 0 },
            sections: 'site-header,cart,mini-cart'
          })
        }).then(this.onCartUpdate)
        return
      }
    }
  }

  // Handle cart API response and update sections with dynamic content
  async onCartUpdate (cartResponse, isFirstLoad = false) {
    cartResponse.json().then( async (responseJson)  => {
      await this.onHandleFreeProduct(responseJson)
      const sections = responseJson.sections ? responseJson.sections : responseJson
      // Replace content for re-rendered site-header section
      const siteHeaderEl = document.querySelector('site-header')
      let newSiteHeaderEl = null
      if (sections['site-header']) {
        newSiteHeaderEl = new DOMParser()
          .parseFromString(sections['site-header'], 'text/html')
      }
      if (siteHeaderEl) {
        siteHeaderEl.replaceContent(newSiteHeaderEl)
      }

      // Replace content for re-rendered blog-listing-header section
      const blogListHeaderEl = document.querySelector('blog-listing-header')
      let newBLogListHeaderEl = null
      if (sections['blog-listing-header']) {
        newBLogListHeaderEl = new DOMParser()
          .parseFromString(sections['blog-listing-header'], 'text/html')
      }
      if (blogListHeaderEl) {
        blogListHeaderEl.replaceContent(newBLogListHeaderEl)
      }

      if (!isFirstLoad) {
        if (!window.location.pathname.includes('/cart')) {
          // Replace content for re-rendered mini-cart section
          const newMiniCartEl = new DOMParser()
          .parseFromString(sections['mini-cart'], 'text/html')
          this.replaceContent(newMiniCartEl)
        } else {
          // Replace content for re-rendered cart section
          const newCartEl = new DOMParser()
          .parseFromString(sections.cart, 'text/html')
          this.replaceContent(newCartEl)
        }
      }
      
      this.setAttribute('data-loading', false)
      this.getHeightHeaderCart()
    })

    document.addEventListener("fg-today-offer:success", (e) => {
      const cartCountEls = document.querySelectorAll('.js-cart-count')
      if (!cartCountEls.length) return
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          const itemCount = cartData.item_count;
          cartCountEls.forEach(cartCountEl => {
            cartCountEl.innerHTML = `(${itemCount})`
          })
        })
        .catch(error => {
          console.error('Error fetching cart data:', error)
        })
    })
  }

  initDetectScroll () {
    if (window.innerWidth < TABLET_BREAK_POINT) {
      window.addEventListener('scroll', _.debounce(() => {
        this.miniCartContainerEl = document.querySelector(MINI_CART_CONTAINER_SELECTOR)
        if (this.miniCartContainerEl) {
          const st = window.pageYOffset || document.documentElement.scrollTop
          if (st > this.lastScrollTop) {
            this.miniCartContainerEl.style.paddingBottom = 0
          } else if (st < this.lastScrollTop) {
            this.miniCartContainerEl.style.paddingBottom = '60px'
          }
          this.lastScrollTop = st <= 0 ? 0 : st
        }
      }, 10), false)
    }
  }

  getHeightHeaderCart () {
    const header = this.querySelector('.js-cart-header')
    if (!header) return 

    const headerHeight = header.offsetHeight
    this.style.setProperty('--cart-header-height', `${headerHeight + 1}px`)
  }
}
customElements.define('shopify-cart', Cart)
